import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private _snackbar = inject(MatSnackBar);

  message: string;
  actionText = 'Ok';
  disappearAfter = 3000;

  showMessage(message: string, duration?: number) {
    this._snackbar.open(message, this.actionText, {
      duration: duration ?? this.disappearAfter
    });
  }
}
